import React from "react";
import { Flex, Box } from "reflexbox";
import styled from "styled-components";
import ReactSwitch from "react-switch";

const Label = styled.div`
    color: rgb(21, 41, 53);
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    display: flex;
    align-items: center;
`;

export const Switch = ({ label, value, onChange }) => {
    return (
        <Flex alignItems="center">
            {label && (
                <Box mr={16}>
                    <Label>{label}</Label>
                </Box>
            )}
            <Box display="flex" alignItems="center">
                <ReactSwitch
                    height={16}
                    width={32}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#0090D1"
                    offColor="#5A6872"
                    onChange={onChange}
                    checked={value}
                />
            </Box>
        </Flex>
    );
};
